<template>
  <!-- 利用组件调用自己实现三级嵌套 -->
  <ul class="sidebar-list">
    <li v-for="(item, index) in lists" :key="index">
      <p :class="{ active: item.Id === itemId }">
        <span class="sidebar-item" @click.prevent.stop="handelClick(index, item)">
          <div v-if="index === 0 && item.ParentFolderId === pid || item.Id === '0'" class="pohot">
            <i class="iconfont icon-download-box"></i>
          </div>
          <div v-if="item.ParentFolderId !== pid && item.ParentFolderId === '' && item.Id !== '0' " class="pohot"><i class="iconfont icon-wenjianjia"></i></div>
          <div v-if="index === 2 && item.ParentFolderId === pid" class="pohot">
            <i class="iconfont icon-rocket"></i>
          </div>
          <div v-if="index === 3 && item.ParentFolderId === pid" class="pohot">
            <i class="iconfont icon-delete"></i>
          </div>
          <div v-if="index === 1 && item.ParentFolderId === pid" class="pohot">
            <i class="iconfont icon-file-text"></i>
          </div>
          <div v-if="index === 4 && item.ParentFolderId === pid" class="pohot">
            <i class="iconfont icon-lajiyoujian"></i>
          </div>
          <i class="sidebar-name">{{ item.DisplayName | sidebarData}}</i>
        </span>
        <span class="unread" v-if="(item.UnreadCount + 0) >= 1 && item.FolderType === 1">{{`(${item.UnreadCount - 0 > 9999 ? "9999+" : item.UnreadCount})`}}</span>
        <span v-if="item.ChildFolders.length" class="fold">
          <i v-if="item.isShow" @click="handelShow(item, index)" class="iconfont icon-caret-down"></i>
          <i v-else @click="handelShow(item, index)" class="iconfont icon-caret-right"></i>
        </span>
      </p>
      <SidebarList class="children" v-if="!item.isShow" :list="item.ChildFolders"></SidebarList>
    </li>
  </ul>
</template>

<script>
import '../../../assets/css/iconfont.css'
export default {
	name: 'SidebarList',
	props: {
		list: {
			type: Array,
			require: true,
			icon: null
		},
		number: {
			type: [String, Number],
			require: true
		},
		pid: {
			type: String,
			require: true
		}
	},
	data() {
		return {
			show: true,
			lists: [],
			itemId: this.$store.state.List.seachForm.ParentFolderId,
			num: 0,
			num1: 10
		}
	},
	created() {
		this.changeList()
	},
	methods: {
		handelClick(index, item) {
			console.log('sssss')
			this.$bus.$emit('closeDialogue', item)
		},
		// 点击
		handelShow(val, index) {
			this.lists[index].isShow = !val.isShow
			this.show = !this.show
		},
		// 在原来的数据上添加了isShow来控制展开闭合的
		changeList() {
			this.lists = this.list.map((item) => {
				item = { ...item, isShow: false }
				return item
			})
		}
	}
}
</script>

<style lang="less" scoped>
.sidebar-list {
	text-align: left;
	p {
		position: relative;
		height: 44px;
		margin: 0;
		padding-left: 48px;
		line-height: 44px;
		font-size: 14px;
		font-weight: 400;
	}
	.active {
		background-color: #005de5;
		color: #fff;
	}
	.sidebar-item {
		display: inline-block;
		width: 80%;
	}
}
.children {
	margin-left: 16px;
}
.fold {
	position: absolute;
	// top: 15px;
	right: 16px;
	transform: rotate(90deg);
}
.pohot {
	position: absolute;
	top: 14px;
	left: 15px;
	width: 16px;
	height: 16px;
	i {
		position: absolute;
		top: -13px;
	}
}
.sidebar-name {
	display: inline-block;
	width: 100px;
	font-style: normal;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
}
.unread {
	position: absolute;
	right: 70px;
}
</style>